import {
  Component,
  ViewChild,
  ViewEncapsulation,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { GoogleMap, GoogleMapsModule, MapMarker } from '@angular/google-maps';
import { AuthenticationService } from '../../../core/auth/services/authentication.service';

@Component({
  selector: 'app-telematics-section-map',
  templateUrl: './telematics-section-map.component.html',
  styleUrls: ['./telematics-section-map.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [GoogleMapsModule, MapMarker],
})
export class TelematicsSectionMapComponent implements OnInit, OnChanges {
  @ViewChild('map', { static: false }) googlemap!: GoogleMap;
  @Input() basicRideCoordinateDto: any;
  @Input() markers: any[] = [];
  @Input() options: any;

  public showData: boolean = false;

  constructor(private readonly _authenticationService: AuthenticationService) {}

  ngOnInit() {
    // Initialize with default map options - always show map
    if (!this.options) {
      this.options = {
        center: { lat: 40.7128, lng: -74.006 },
        zoom: 10,
        mapTypeId: 'roadmap',
      };
    }
    // Ensure the map is always visible by default
    this.showData = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['markers'] && this.markers && this.markers.length > 0) {
      this.showData = true;
    }
    if (changes['options'] && this.options) {
      // Update map options when they change
    }
  }
}
